import styled from '@emotion/styled';
import { breakpoints, spacing } from '@naf/theme';
import { Typography } from '@naf-simba/building-blocks-typography';
import { Label as InputLabel, Input } from '@naf/input';

export const Title = styled(Typography)`
  margin-bottom: ${spacing.space16};
`;

export const StyledLabel = styled(InputLabel)`
  p {
    margin: 0 !important;
  }
`;

export const Search = styled.div`
  display: flex;
  gap: ${spacing.space16};

  @media (max-width: ${breakpoints.s}) {
    gap: ${spacing.space8};
  }
`;

export const SearchInput = styled(Input)`
  flex: 1;
  min-width: 0;
  width: 100%;
  max-width: 256px;
`;

export const SpinnerWrapper = styled.div`
  margin-top: ${spacing.space24};
  width: fit-content;

  @media (max-width: ${breakpoints.s}) {
    margin-left: auto;
    margin-right: auto;
  }
`;

export const ErrorMessage = styled.div`
  margin-top: ${spacing.space16};
`;
